import axios from 'axios';
import store from '../store';
import {errorHandler, XHR_STATUS_DEFAULT} from '../utils/portuna';
import TopMessageHandler from './topMessageHandler';

export function isAllowedModule(module: string)
{
    return Object.values(store.state.layoutData.user.modules).includes(module) || isAllowedEmployeeResource(module) || false;
}

export function isAllowedEmployeeResource(module: string)
{
    return store.state.layoutData.employee_configuration?.allowed_resources.includes(module) || false;
}

export function hasEmployeeSubModule(module: string)
{
    return store.state.layoutData.employee_configuration?.sub_module.includes(module) || false;
}

export function impersonateUser(userId: number, origin: string)
{
    axios.post('/ajax/set-impersonate-user/user-id/' + userId + '/origin/' + origin)
    .then(response =>
    {
        const {
                  data,
                  status,
              } = response.data;

        if (status !== XHR_STATUS_DEFAULT)
        {
            throw response;
        }

        TopMessageHandler.success(data.message);

        setTimeout(() =>
        {
            window.location.href = '/';
        }, 2_500);
    })
    .catch(errorHandler);
}